var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ProviderType } from 'lavva.exalushome/build/js/Services/Updates/IUpdatesProvider';
import { PortosService } from '../../Portos';
export class PortosDevicesUpdatesProvider {
    constructor(extInfo, runtimeInfo) {
        this._apiVersion = extInfo.APIVersion;
        this._extenstionVersion = extInfo.ExtensionVersion;
        this._protocolExtGuid = extInfo.ExtensionGuid;
        this._runtimeInfo = runtimeInfo;
    }
    get ExtensionGuid() {
        return this._protocolExtGuid;
    }
    get ProtocolGuid() {
        return PortosService.PortosExtensionGuid;
    }
    get AvailableExtensionVersion() {
        return this._extenstionVersion;
    }
    get AvailableApiVersion() {
        return this._apiVersion;
    }
    get ProviderType() {
        return ProviderType.Device;
    }
    GetUpdateProviderName() {
        return `${PortosDevicesUpdatesProvider.ProviderName}_${this._apiVersion}_${this._extenstionVersion}`;
    }
    GetAvailableUpdateAsync(device) {
        throw new Error('Method not implemented.');
    }
    InstallUpdateAsync(update, updateProgress, updateAction) {
        throw new Error('Method not implemented.');
    }
    GetSoftwareVersionAsync(device) {
        throw new Error('Method not implemented.');
    }
    CheckUpdateBulkAsync(reloadCache) {
        return __awaiter(this, void 0, void 0, function* () {
            return [];
        });
    }
    InstalUpdateBulkAsync(deviceGuids, updateProgress, updateAction) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error('Method not implemented.');
        });
    }
}
PortosDevicesUpdatesProvider.ProviderName = "PortosDeviceUpdateProvider";
//# sourceMappingURL=PortosDevicesUpdatesProvider.js.map